(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    

class FaqSection {

  constructor(root) {

    this.root = root;

    this.singleOpen =
      root.dataset.singleOpen === 'true';

    this.items = Array.from(
      root.querySelectorAll('[data-faq-item]')
    );

    this.searchInput =
      root.querySelector('[id^="FaqSearch-"]');

    this.filterWrap =
      root.querySelector('[id^="FaqFilters-"]');

    this.noResults =
      root.querySelector('[id^="FaqNoResults-"]');

    this.activeFilter = 'all';


    this.items.forEach((item) => {

      const btn =
        item.querySelector('.faq-question');

      const panel =
        item.querySelector('.faq-answer');


      if (item.classList.contains('is-open')) {

        panel.style.maxHeight =
          panel.scrollHeight + 'px';

      }


      btn.addEventListener(
        'click',
        () => this.toggleItem(
          item,
          btn,
          panel
        )
      );

    });



    if (this.searchInput) {

      this.searchInput.addEventListener(
        'input',
        () => this.applyFilters()
      );

    }



    if (this.filterWrap) {

      this.filterWrap.addEventListener(
        'click',
        (e) => {

          const pill =
            e.target.closest(
              '[data-faq-filter]'
            );

          if (!pill) return;


          this.filterWrap
            .querySelectorAll(
              '.faq-filter-pill'
            )
            .forEach((p) => {

              p.classList.remove(
                'is-active'
              );

              p.setAttribute(
                'aria-selected',
                'false'
              );

            });


          pill.classList.add(
            'is-active'
          );

          pill.setAttribute(
            'aria-selected',
            'true'
          );


          this.activeFilter =
            pill.dataset.faqFilter;


          this.applyFilters();

        }
      );

    }

  }



  toggleItem(
    item,
    btn,
    panel
  ) {

    const isOpen =
      item.classList.contains(
        'is-open'
      );


    if (this.singleOpen) {

      this.items.forEach(
        (other) => {

          if (
            other !== item &&
            other.classList.contains(
              'is-open'
            )
          ) {

            other.classList.remove(
              'is-open'
            );

            other
              .querySelector(
                '.faq-question'
              )
              .setAttribute(
                'aria-expanded',
                'false'
              );

            other
              .querySelector(
                '.faq-answer'
              )
              .style.maxHeight = null;

          }

        }
      );

    }


    if (isOpen) {

      item.classList.remove(
        'is-open'
      );

      btn.setAttribute(
        'aria-expanded',
        'false'
      );

      panel.style.maxHeight =
        null;

    } else {

      item.classList.add(
        'is-open'
      );

      btn.setAttribute(
        'aria-expanded',
        'true'
      );

      panel.style.maxHeight =
        panel.scrollHeight + 'px';

    }

  }



  applyFilters() {

    const term =
      this.searchInput
        ? this.searchInput.value
            .trim()
            .toLowerCase()
        : '';


    let visibleCount = 0;


    this.items.forEach(
      (item) => {

        const matchesCategory =
          this.activeFilter === 'all' ||
          item.dataset.category ===
            this.activeFilter;


        const matchesSearch =
          term === '' ||
          item.dataset.question.includes(
            term
          );


        const visible =
          matchesCategory &&
          matchesSearch;


        item.hidden =
          !visible;


        if (visible) {
          visibleCount += 1;
        }

      }
    );


    if (this.noResults) {

      this.noResults.classList.toggle(
        'is-visible',
        visibleCount === 0
      );

    }

  }

}



document
  .querySelectorAll('.faq-section')
  .forEach(
    (el) => new FaqSection(el)
  );


  } catch(e) { console.error(e); }
})();
})();
